var map = {
	"./0000.png": 83960,
	"./0001.png": 52225,
	"./0002.png": 3242,
	"./0003.png": 58451,
	"./0004.png": 74844,
	"./0005.png": 87909,
	"./0006.png": 16110,
	"./0007.png": 59127,
	"./0008.png": 8592,
	"./0009.png": 5497,
	"./0010.png": 34211,
	"./0011.png": 16634,
	"./0012.png": 46801,
	"./0013.png": 32584,
	"./0014.png": 24103,
	"./Adolph.png": 77702,
	"./Aileen.png": 99906,
	"./Angela.png": 89620,
	"./Anna.png": 63094,
	"./Annabel.png": 73697,
	"./Barry.png": 69214,
	"./Becky.png": 25120,
	"./Belle.png": 25314,
	"./Bertha.png": 79812,
	"./Bill.png": 38115,
	"./Bob.png": 28507,
	"./Bonny.png": 86172,
	"./Brian.png": 50094,
	"./Brittany.png": 19221,
	"./Bruce.png": 66315,
	"./Bubu.png": 11308,
	"./Candice.png": 62037,
	"./Celia.png": 48520,
	"./Chloe.png": 22297,
	"./Christine.png": 30677,
	"./Colin.png": 14433,
	"./Connie.png": 69288,
	"./Curt.png": 47262,
	"./Cynthia.png": 83342,
	"./Dan.png": 39679,
	"./Danny.png": 31348,
	"./Darcy.png": 65539,
	"./Darren.png": 9372,
	"./Dave.png": 65370,
	"./Debby.png": 35584,
	"./Dolly.png": 95002,
	"./Doreen.png": 32105,
	"./Dorothy.png": 56941,
	"./Duke.png": 70745,
	"./Duncan.png": 49477,
	"./Edison.png": 29936,
	"./Edward.png": 21541,
	"./Edwin.png": 98609,
	"./Eileen.png": 89502,
	"./Eli.png": 114,
	"./Ellie.png": 28273,
	"./Eric.png": 79049,
	"./Erica.png": 75604,
	"./Felix.png": 56660,
	"./Flora.png": 56104,
	"./Fred.png": 62047,
	"./Gary.png": 23163,
	"./Ginny.png": 22027,
	"./Grace.png": 99670,
	"./Greg.png": 3643,
	"./Hank.png": 11040,
	"./Hannah.png": 8250,
	"./Honey.png": 3867,
	"./Ida.png": 46833,
	"./Irene.png": 7939,
	"./Isabella.png": 18619,
	"./Ivan.png": 90980,
	"./Ivy.png": 480,
	"./James.png": 11958,
	"./Jamie.png": 80892,
	"./Jane.png": 34228,
	"./Jay.png": 22514,
	"./Jeanie.png": 93899,
	"./Jeff.png": 53019,
	"./Jenny.png": 7154,
	"./Jessy.png": 77344,
	"./Johnny.png": 69584,
	"./Josh.png": 41832,
	"./Judy.png": 65410,
	"./Julia.png": 67545,
	"./Kate.png": 62941,
	"./Kay.png": 89119,
	"./Kelly.png": 71315,
	"./Kenny.png": 19243,
	"./Kirk.png": 48477,
	"./Laura.png": 76927,
	"./Lena.png": 49314,
	"./Leon.png": 39934,
	"./Lewis.png": 3686,
	"./Lisa.png": 87801,
	"./Liz.png": 19579,
	"./Luda.png": 63924,
	"./Luna.png": 88146,
	"./Marvin.png": 73171,
	"./Matt.png": 99094,
	"./Maurice.png": 76346,
	"./Meg.png": 16551,
	"./Merle.png": 24875,
	"./Michael.png": 11345,
	"./Momo.png": 73416,
	"./Myron.png": 30717,
	"./Natalie.png": 54450,
	"./Nathan.png": 92710,
	"./Neal.png": 62516,
	"./Nelson.png": 43051,
	"./Nina.png": 17292,
	"./Nita.png": 49674,
	"./Odelia.png": 5188,
	"./Olivia.png": 9526,
	"./Oscar.png": 41130,
	"./Parker.png": 56257,
	"./Pearce.png": 78864,
	"./Peter.png": 19468,
	"./Polly.png": 19790,
	"./Renee.png": 53103,
	"./Richard.png": 84243,
	"./Rita.png": 4846,
	"./Robin.png": 8470,
	"./Rod.png": 68029,
	"./Rosa.png": 98689,
	"./Roxanne.png": 6451,
	"./Roy.png": 14888,
	"./Sally.png": 30215,
	"./Sammy.png": 92685,
	"./Sara.png": 95319,
	"./Sarah.png": 10623,
	"./Scott.png": 71603,
	"./Sean.png": 35493,
	"./Sharon.png": 67775,
	"./Stanley.png": 91020,
	"./Stephanie.png": 82719,
	"./Steven.png": 69101,
	"./Steward.png": 19406,
	"./Taylor.png": 91361,
	"./Teddy.png": 18388,
	"./Terry.png": 95984,
	"./Thera.png": 21460,
	"./Timothy.png": 84472,
	"./Tina.png": 14094,
	"./Tommy.png": 47364,
	"./Tony.png": 25368,
	"./Una.png": 87172,
	"./Vanessa.png": 54997,
	"./Vicky.png": 5904,
	"./Viola.png": 32661,
	"./Vivi.png": 18228,
	"./Wendy.png": 98061,
	"./Wesley.png": 20519,
	"./Willie.png": 74758,
	"./Willy.png": 39395,
	"./Winston.png": 67090,
	"./Zach.png": 33858,
	"./black.png": 35675,
	"./default.png": 22909,
	"./kid-Aileen.png": 13287,
	"./kid-Anna.png": 64995,
	"./kid-Annabel.png": 34126,
	"./kid-Barry.png": 9233,
	"./kid-Belle.png": 40593,
	"./kid-Brian.png": 27865,
	"./kid-Brittany.png": 42044,
	"./kid-Bruce.png": 78616,
	"./kid-Bubu.png": 60497,
	"./kid-Candice.png": 24226,
	"./kid-Curt.png": 17519,
	"./kid-Darren.png": 92945,
	"./kid-Dave.png": 85027,
	"./kid-Debby.png": 68095,
	"./kid-Duke.png": 53892,
	"./kid-Duncan.png": 79424,
	"./kid-Edward.png": 89504,
	"./kid-Eileen.png": 25811,
	"./kid-Ellie.png": 92002,
	"./kid-Eric.png": 74892,
	"./kid-Fred.png": 13242,
	"./kid-Gary.png": 25474,
	"./kid-Ginny.png": 30132,
	"./kid-Grace.png": 17269,
	"./kid-Hannah.png": 79807,
	"./kid-Ivy.png": 93255,
	"./kid-James.png": 24997,
	"./kid-Jane.png": 7049,
	"./kid-Josh.png": 88177,
	"./kid-Julia.png": 81642,
	"./kid-Lewis.png": 27021,
	"./kid-Lisa.png": 79380,
	"./kid-Liz.png": 3656,
	"./kid-Maurice.png": 8705,
	"./kid-Meg.png": 49020,
	"./kid-Michael.png": 67306,
	"./kid-Olivia.png": 12803,
	"./kid-Pearce.png": 22433,
	"./kid-Robin.png": 18473,
	"./kid-Rosa.png": 89192,
	"./kid-Roy.png": 74095,
	"./kid-Sally.png": 8292,
	"./kid-Sara.png": 79742,
	"./kid-Stanley.png": 69795,
	"./kid-Steven.png": 16312,
	"./kid-Teddy.png": 48207,
	"./kid-Timothy.png": 31327,
	"./kid-Tommy.png": 96635,
	"./kid-Vicky.png": 7903,
	"./kid-Willy.png": 95344,
	"./none.png": 11078,
	"./white.png": 11493,
	"./佛印.png": 40173,
	"./刮骨療傷的關羽.png": 21078,
	"./劉備.png": 20146,
	"./南極仙翁.png": 79022,
	"./唐太宗.png": 74895,
	"./唐明皇.png": 26515,
	"./圍棋仕女嘉嘉.png": 94530,
	"./孫悟空.png": 60074,
	"./孫權.png": 24148,
	"./小嘉嘉.png": 65051,
	"./小龍公主.png": 45987,
	"./帥林老師.png": 67816,
	"./張飛.png": 42948,
	"./德川家康.png": 63541,
	"./志祺七七.png": 89185,
	"./曹操.png": 93366,
	"./曼尼 Manny.png": 29187,
	"./楊貴妃.png": 85615,
	"./溫柔的嘉嘉老師.png": 86479,
	"./牛魔王.png": 51374,
	"./白小嘉.png": 10667,
	"./白居易.png": 81955,
	"./目標成為職業的8歲嘉嘉.png": 58081,
	"./織田信長.png": 62640,
	"./蕭正浩.png": 95071,
	"./蘇東坡.png": 32483,
	"./許皓鋐.png": 56498,
	"./謝依旻.png": 23123,
	"./豐臣秀吉.png": 62666,
	"./貴妃的狗.png": 71684,
	"./采潔.png": 92837,
	"./鐵扇公主.png": 79463,
	"./關羽.png": 14449,
	"./飛鳥涼不涼 Sam.png": 37640,
	"./鬥戰勝佛.png": 89419,
	"./黑嘉嘉.png": 62465,
	"./黑小嘉.png": 50743,
	"./齊天大聖.png": 18328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6675;